<template>
    <div class="labpersonal">
        <div class="labpersonal-inner" v-if="!isLoading">
            <div class="lk-forms lk-forms1" v-bind:class="{ 'lk-forms--loading': isLoading }" v-if="viewMode == 'company'">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <form v-on:submit="getLabData()">
                                <div class="row">
                                    <div class="col-md-4">
                                        <h3>Анализы</h3>

                                        <div class="form-group">
                                            <label>Дата забора материала</label>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class='input-group date'>
                                                        <date-picker v-model="filterDateStart" lang="ru" format="DD.MM.YYYY" :first-day-of-week="1">
                                                            <span slot="calendar-icon" class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
                                                        </date-picker>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class='input-group date'>
                                                        <date-picker v-model="filterDateEnd" lang="ru" format="DD.MM.YYYY" :first-day-of-week="1">
                                                            <span slot="calendar-icon" class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
                                                        </date-picker>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="agent">Заказчик</label>
                                            <select v-model="filterClient" id="agent" class="form-control">
                                                <option selected value="">Выберите заказчика</option>
                                                <option v-for="client in clientsList" v-bind:value="client">{{ client }}</option>
                                            </select>
                                        </div>

                                        <div class="form-group form-group--multiselect">
                                            <label>Врач</label>
                                            <v-select multiple v-model="filterDoctorName" return-object :options="referrersList" :searchable="true" :placeholder="'Выберите врача'">
                                                <template slot="option" slot-scope="option">
                                                    {{ option.label }}
                                                </template>
                                                <template slot="no-options" :class="'select-hidden'">-</template>
                                            </v-select>
                                        </div>

                                    </div>

                                    <div class="col-md-4">
                                        <h3>Пациент</h3>
                                        <div class="form-group">
                                            <label for="last-name">Фамилия</label>
                                            <input v-model="filterPatientLastName" type="text" class="form-control" id="last-name">
                                        </div>
                                        <div class="form-group">
                                            <label for="name">Имя</label>
                                            <input v-model="filterPatientName" type="text" class="form-control" id="name">
                                        </div>
                                        <div class="form-group">
                                            <label for="second-name">Отчество</label>
                                            <input v-model="filterPatientSecondName" type="text" class="form-control" id="second-name">
                                        </div>
                                        <div class="form-group">
                                            <label>Дата рождения</label>
                                            <div class='input-group date'>
                                                <date-picker v-model="filterPatientBirthDate" lang="ru" format="DD.MM.YYYY" :first-day-of-week="1">
                                                    <span slot="calendar-icon" class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <h3>Исследования</h3>
                                        <div class="form-group form-group--multiselect">
                                            <label>Наименование</label>
                                            <v-select multiple v-model="filterServices" return-object :options="servicesList" :searchable="true" :placeholder="'Выберите исследование'">
                                                <template slot="option" slot-scope="option">
                                                    {{ option.label }}
                                                </template>
                                                <template slot="no-options" :class="'select-hidden'">-</template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button v-on:click="clearFilter()" v-bind:disabled="!isFiltered" v-bind:class="{'disabled' : !isFiltered}" type="button" class="btn btn-primary pull-right ml20">СБРОСИТЬ ФИЛЬТР</button>
                                        <button v-on:click="getLabData()" type="button" class="btn btn-primary pull-right ml20">ИСКАТЬ РЕЗУЛЬТАТЫ</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="lk-forms lk-forms2" v-bind:class="{ 'lk-forms--loading': isLoading }">
                <form action="">
                    <ul class="nav nav-tabs">
                        <li class="active"><a href="#an" data-toggle="tab">Анализы</a></li>
                        <li><a href="#pac" data-toggle="tab">Пациент</a></li>
                        <li><a href="#iss" data-toggle="tab">Исследования</a></li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="an">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Дата забора материала</label>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class='input-group date'>
                                                <date-picker v-model="filterDateStart" lang="ru" format="DD.MM.YYYY" :first-day-of-week="1">
                                                    <span slot="calendar-icon" class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
                                                </date-picker>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class='input-group date'>
                                                <date-picker v-model="filterDateEnd" lang="ru" format="DD.MM.YYYY" :first-day-of-week="1">
                                                    <span slot="calendar-icon" class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="agent-mobile">Заказчик</label>
                                    <select v-model="filterClient" id="agent-mobile" class="form-control">
                                        <option value="">Выберите агента</option>
                                        <option v-for="client in clientsList" v-bind:value="client">{{ client }}</option>
                                    </select>
                                </div>
                                <div class="form-group form-group--multiselect">
                                    <label>Врач</label>
                                    <v-select multiple v-model="filterDoctorName" return-object :options="referrersList" :searchable="true" :placeholder="'Выберите врача'">
                                        <template slot="option" slot-scope="option">
                                            {{ option.label }}
                                        </template>
                                        <template slot="no-options" :class="'select-hidden'">-</template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="pac">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="last-name-mobile">Фамилия</label>
                                    <input v-model="filterPatientLastName" type="text" class="form-control" id="last-name-mobile">
                                </div>
                                <div class="form-group">
                                    <label for="name-mobile">Имя</label>
                                    <input v-model="filterPatientName" type="text" class="form-control" id="name-mobile">
                                </div>
                                <div class="form-group">
                                    <label for="second-name-mobile">Отчество</label>
                                    <input v-model="filterPatientSecondName" type="text" class="form-control" id="second-name-mobile">
                                </div>
                                <div class="form-group">
                                    <label>Дата рождения</label>
                                    <div class='input-group date'>
                                        <date-picker v-model="filterPatientBirthDate" lang="ru" format="DD.MM.YYYY" :first-day-of-week="1">
                                            <span slot="calendar-icon" class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
                                        </date-picker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="iss">
                            <div class="col-md-12">
                                <div class="form-group form-group--multiselect">
                                    <label>Наименование</label>
                                    <v-select multiple v-model="filterServices" return-object :options="servicesList" :searchable="true" :placeholder="'Выберите исследование'">
                                        <template slot="option" slot-scope="option">
                                            {{ option.label }}
                                        </template>
                                        <template slot="no-options" :class="'select-hidden'">-</template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid sBlock">
                        <div class="row">
                            <div class="col-md-12">
                                <input v-on:click="getLabData()" class="btn btn-primary" value="ИСКАТЬ РЕЗУЛЬТАТЫ">
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="container">
                <div class="row row--padding">
                    <ul class="pagination pagination--top" v-if="pagination.pagesCount > 1">
                        <li class="next" v-on:click="pagination.currentPage = 0"><a>«</a></li>
                        <li class="next" v-on:click="paginationPrevPage()"><a>‹</a></li>
                        <li v-for="index in computedPagesCount" v-on:click="pagination.currentPage = index - 1" v-bind:class="{ 'active' : index - 1 == pagination.currentPage }">
                            <a>{{ index }}</a>
                        </li>
                        <li class="next" v-on:click="paginationNextPage()"><a>›</a></li>
                        <li class="next" v-on:click="pagination.currentPage = pagination.pagesCount - 1"><a>»</a></li>
                    </ul>
                    <div v-if="totalResultsCount > 1" class="results-count">Найдено результатов: {{ totalResultsCount }}</div>
                </div>
                <div class="row">
                    <div class="col-md-12 tableWr">
                        <table class="table historyT" id="exportTable">
                            <tbody>
                                <tr class="trForTh">
                                    <th></th>
                                    <th>
                                        <span class="pointed" @click="sortList('date')">
                                            Дата&nbsp;&nbsp;
                                            <span v-if="sort.date.active == true && sort.date.reverse == true"
                                                  class="glyphicon glyphicon-menu-down"
                                                  aria-hidden="true"></span>
                                            <span v-else=""
                                                  class="glyphicon glyphicon-menu-up"
                                                  aria-hidden="true"></span>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="pointed" @click="sortList('patientName')">
                                            Пациент&nbsp;&nbsp;
                                            <span v-if="sort.patientName.active == true && sort.patientName.reverse == true"
                                                  class="glyphicon glyphicon-menu-down"
                                                  aria-hidden="true"></span>
                                            <span v-else=""
                                                  class="glyphicon glyphicon-menu-up"
                                                  aria-hidden="true"></span>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="pointed" @click="sortList('patientBirthDate')">
                                            Дата рождения&nbsp;&nbsp;
                                            <span v-if="sort.patientBirthDate.active == true && sort.patientBirthDate.reverse == true"
                                                  class="glyphicon glyphicon-menu-down"
                                                  aria-hidden="true"></span>
                                            <span v-else=""
                                                  class="glyphicon glyphicon-menu-up"
                                                  aria-hidden="true"></span>
                                        </span>
                                    </th>
                                    <th></th>
                                    <th><span v-on:click="selectAllResults()" class="checkAll">Все</span></th>
                                    <th class="alignCenter"></th>
                                </tr>

                                <template v-for="labResult in labData[pagination.currentPage]">
                                    <tr class="js-watchCheck watchCheck"
                                        v-bind:class="{ active: currentResult == labResult.id }"
                                        v-on:click="selectCurrentResult(labResult.id)"
                                        v-bind:data-id="labResult.id">
                                        <td class="status alignCenter">
                                            <img v-bind:src="'/local/templates/personal/assets/img/' + labResult.status + '.png'" v-bind:title="statusNames[labResult.status]">
                                        </td>
                                        <td>{{ labResult.date }}</td>
                                        <td>{{ labResult.patientName }}<span class="glyphicon glyphicon-menu-down" aria-hidden="true"></span></td>
                                        <td>{{ labResult.patientBirthDate }}</td>
                                        <td></td>
                                        <td class="checkPosition"><input type="checkbox" v-on:click.stop="" v-bind:value="labResult.id" v-model="listForDownload"></td>
                                        <td class="alignCenter"><a v-on:click.stop="getPDF([labResult.id])"><b>СКАЧАТЬ</b></a></td>
                                    </tr>

                                    <template v-if="currentResult == labResult.id">
                                        <tr class="js-watchResult result">
                                            <th></th>
                                            <th colspan="3">Название</th>
                                            <th>Результат</th>
                                            <th colspan="2">Референсные значения</th>
                                        </tr>

                                        <tr v-for="row in labResult.tests" v-bind:class="row.type" class="js-watchResult result">
                                            <td></td>
                                            <td colspan="3">
                                                <span v-bind:class="row.type">{{ row.name }}<span v-if="row.type == 'test'">:</span></span>
                                            </td>
                                            <td>{{ row.value }}</td>
                                            <td colspan="2">{{ row.norm }}</td>
                                        </tr>

                                    </template>
                                </template>

                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div v-if="totalResultsCount > 1" class="results-count">Найдено результатов: {{ totalResultsCount }}</div>
                </div>
            </div>

            <div class="container botTable">
                <div class="row row--padding">
                    <div class="col-lg-6 col-md-6">
                        <ul class="pagination" v-if="pagination.pagesCount > 1">
                            <li class="next" v-on:click="pagination.currentPage = 0"><a>«</a></li>
                            <li class="next" v-on:click="paginationPrevPage()"><a>‹</a></li>
                            <li v-for="index in computedPagesCount" v-on:click="pagination.currentPage = index - 1" v-bind:class="{ 'active' : index - 1 == pagination.currentPage }">
                                <a>{{ index }}</a>
                            </li>
                            <li class="next" v-on:click="paginationNextPage()"><a>›</a></li>
                            <li class="next" v-on:click="pagination.currentPage = pagination.pagesCount - 1"><a>»</a></li>
                        </ul>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="row row--padding">
                            <button
                                    v-bind:disabled="!listForDownload.length"
                                    v-on:click="getPDF(listForDownload)"
                                    type="button" class="btn btn-primary pull-right ml20 downloadSelected"
                            >
                                СКАЧАТЬ ВЫБРАННОЕ
                            </button>
                            <a v-if="viewMode == 'company'" v-on:click="getXLSX()" class="btn btn-default pull-right ml20 downloadExcel">
                                СОХРАНИТЬ ТАБЛИЦУ В ФАЙЛЕ EXCEL
                            </a>
                        </div>
                        <div v-if="viewMode == 'individual'" class="row send-pdf-block">
                            <template v-if="!isEmailFormSuccess">
                                <button
                                        v-bind:disabled="!listForDownload.length"
                                        v-on:click="sendEmail(listForDownload)"
                                        type="button" class="btn btn-primary pull-right ml20 downloadSelected"
                                >
                                    ОТПРАВИТЬ НА EMAIL
                                </button>
                                <div class="send-pdf-input pull-right">
                                    <input v-model="userEmail" type="text" placeholder="Введите свой Email" class="form-control">
                                    <div v-if="formErrors.length" class="send-pdf-errors">
                                        <div v-for="error in formErrors">{{ error }}</div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="send-pdf-success pull-right">
                                    Результаты анализов отправлены
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="labpersonal-preloader" v-else="">
            <img src="/local/templates/personal/assets/img/preloader.gif">
            <h3>Загрузка результатов</h3>
        </div>
    </div>

</template>

<script>
    import axios from 'axios';
    import DatePicker from 'vue2-datepicker';
    import vSelect from 'vue-select';

    let date = new Date();

    export default {
        props: ['preset'],
        components: { DatePicker, vSelect },
        data() {
            return{
                labData: [],
                labDataRaw: [],
                currentResult: null,
                agentsList: [],
                clientsList: [],
                servicesList: [],
                referrersList: [],
                filterAgent: null,
                filterClient: '',
                filterDateStart: (this.preset == "company") ? new Date(date.getFullYear(), date.getMonth()) : null,
                filterDateEnd: '', //new Date(date.getFullYear(), date.getMonth() + 1, 0),
                filterDoctorName: [],
                filterPatientName: '',
                filterPatientSecondName: '',
                filterPatientLastName: '',
                filterPatientBirthDate: '',
                filterServices: [],
                listForDownload: [],
                statusNames: {"done": "Полная готовность", "wait": "Частичная готовность"},
                isLoading: false,
                isFiltered: false,
                viewMode: 'individual',
                userID: null,
                userEmail: '',
                totalResultsCount: 0,
                pagination: {
                    itemsPerPage: 25,
                    pagesCount: 1,
                    currentPage: 0,
                },
                formErrors: [],
                isEmailFormSuccess: false,
                sort: {
                    date: {
                        active: false,
                        reverse: false
                    },
                    patientName: {
                        active: false,
                        reverse: false
                    },
                    patientBirthDate: {
                        active: false,
                        reverse: false
                    },
                }
            }
        },
        computed: {
            computedPagesCount: function () {
                var pages = [];
                var quantity = 4;
                var start = -1;
                if (this.pagination.currentPage == 0) {
                    start = 1;
                    quantity += 2;
                } else if (this.pagination.currentPage == 1) {
                    start = 0;
                    quantity += 1;
                } else if (this.pagination.currentPage == this.pagination.pagesCount - 1) {
                    start = -3;
                    quantity -= 2;
                } else if (this.pagination.currentPage == this.pagination.pagesCount - 2) {
                    start = -2;
                    quantity -= 1;
                }
                for (var i = start; i < quantity; i++) {
                    pages.push(this.pagination.currentPage + i);
                }
                return pages;
            }
        },
        watch: {
            filterDate: function () {
                this.getLabData();
            },
        },
        methods: {
            getLabData: function() {
                this.isLoading = true;
                axios.get('/api/personal/', {
                    params: {
                        method: 'getLabData',
                        filterDateStart: (this.filterDateStart) ? Math.floor(this.filterDateStart.getTime() / 1000) : '',
                        filterDateEnd: (this.filterDateEnd) ? Math.floor(this.filterDateEnd.getTime() / 1000) + 86400 : '',
                        filterClient: this.filterClient,
                        filterDoctorName: this.filterDoctorName,
                        filterPatientName: this.filterPatientName,
                        filterPatientSecondName: this.filterPatientSecondName,
                        filterPatientLastName: this.filterPatientLastName,
                        filterPatientBirthDate: (this.filterPatientBirthDate) ? Math.floor(this.filterPatientBirthDate.getTime() / 1000) : '',
                        filterServices: this.filterServices,
                    }
                }).then(response => {
                    var results = Object.values(response.data.results);
                    this.labDataRaw = results;
                    this.totalResultsCount = results.length;
                    this.isFiltered = !!response.data.isFiltered;
                    // pagination
                    var pagesCount = Math.ceil(results.length / this.pagination.itemsPerPage);
                    var pagesContent = this.lodash.chunk(results, this.pagination.itemsPerPage);
                    this.pagination.pagesCount = pagesCount;
                    this.labData = pagesContent;
                    this.pagination.currentPage = 0;

                    this.servicesList = response.data.services;
                    this.viewMode = response.data.mode;
                    this.userID = response.data.userID;
                    this.userEmail = response.data.userEmail;
                    this.listForDownload = [];
                    this.isLoading = false;

                    if (this.viewMode == 'individual' && this.totalResultsCount == 1) {
                        this.currentResult = this.labData[0][0].id;
                        this.listForDownload.push(this.labData[0][0].id);
                    }

                    console.log('requestExecutionTime: ' + response.data.requestExecutionTime + ' s');

                    if (this.preset == "company") {
                        this.getReferrers();
                    }

                });
            },

            sortList: function (type) {
                let currentThis = this;
                if (this.sort[type].active == true) {
                    this.sort[type].reverse = !this.sort[type].reverse;
                } else {
                    for (var i in this.sort) {
                        this.sort[i].active = false;
                        this.sort[i].reverse = false;
                    }
                    this.sort[type].active = true;
                }
                let currentLabData = JSON.parse(JSON.stringify(this.labDataRaw));
                currentLabData.sort(function (a, b) {
                    let currentA = Object.assign({}, a);
                    let currentB = Object.assign({}, b);
                    if (type == 'patientBirthDate') {
                        let arrA = currentA[type].split('/');
                        let arrB = currentB[type].split('/');
                        currentA[type] = arrA[2] + arrA[0] + arrA[1];
                        currentB[type] = arrB[2] + arrB[0] + arrB[1];
                    }
                    if (currentThis.sort[type].reverse) {
                        if (currentA[type] > currentB[type]) {
                            return -1;
                        } else {
                            return 1;
                        }
                    } else {
                        if (currentA[type] > currentB[type]) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                });
                var pagesContent = this.lodash.chunk(currentLabData, this.pagination.itemsPerPage);
                this.labData = pagesContent;
            },

            clearFilter: function() {
                this.filterAgent = null;
                this.filterClient = '';
                this.filterDateStart = null;
                this.filterDateEnd = null;
                this.filterDoctorName = [];
                this.filterPatientName = '';
                this.filterPatientSecondName = '';
                this.filterPatientLastName = '';
                this.filterPatientBirthDate = '';
                this.filterServices = [];
                this.getLabData();
            },

            getAgents: function() {
                axios.get('/api/personal/', {
                    params: {
                        method: 'getAgents',
                    }
                }).then(response => {
                    this.agentsList = response.data;
                });
            },

            getClients: function() {
                axios.get('/api/personal/', {
                    params: {
                        method: 'getClients',
                    }
                }).then(response => {
                    this.clientsList = response.data;
                });
            },

            getReferrers: function() {
                axios.get('/api/personal/', {
                    params: {
                        method: 'getReferrers',
                        filterClient: this.filterClient,
                    }
                }).then(response => {
                    this.referrersList = response.data;
                    var filterReferrers = this.filterDoctorName.filter(doctorName => Object.values(this.referrersList).join('').indexOf(doctorName) >= 0);
                    if (this.filterDoctorName.length !== filterReferrers.length) {
                        this.filterDoctorName = [];
                        this.getLabData();
                    }
                });
            },

            selectCurrentResult: function (id) {
                this.currentResult = (this.currentResult != id) ? id : null;
            },

            getXLSX: function () {
                axios.post('/api/personal/', {
                    method: 'getXLSX',
                    id: this.currentResult,
                    data: this.labDataRaw
                }).then(response => {
                    const link = document.createElement('a');
                    link.href = response.data.path;
                    document.body.appendChild(link);
                    link.click();
                });
            },

            getPDF: function (list) {
                axios.post('/api/personal/', {
                    method: 'getPDF',
                    id: list,
                }).then(response => {
                    const link = document.createElement('a');
                    link.href = response.data;
                    link.download = "";
                    document.body.appendChild(link);
                    link.click();
                });
            },

            sendEmail: function (list) {
                if (this.checkForm()) {
                    axios.post('/api/personal/', {
                        method: 'sendEmailPDF',
                        email: this.userEmail,
                        id: list,
                    }).then(response => {
                        if (response.data) {
                            this.isEmailFormSuccess = true;
                        } else {
                            this.formErrors.push('Ошибка отправки формы!');
                        }
                    });
                }
            },

            checkForm: function () {
                this.formErrors = [];
                if (!this.userEmail) {
                    this.formErrors.push('Укажите электронную почту.');
                } else if (!this.validateEmail(this.userEmail)) {
                    this.formErrors.push('Укажите корректный Email.');
                }
                if (!this.formErrors.length) {
                    return true;
                }
            },

            validateEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            selectAllResults: function () {
                if (this.listForDownload.length != Object.keys(this.labDataRaw).length) {
                    this.listForDownload = this.labDataRaw.map(x => x.id);
                } else {
                    this.listForDownload = [];
                }
            },

            paginationPrevPage: function () {
                if (this.pagination.currentPage != 0) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                }
            },

            paginationNextPage: function () {
                if (this.pagination.currentPage < this.pagination.pagesCount - 1) {
                    this.pagination.currentPage = this.pagination.currentPage + 1
                }
            },

        },
        created: function () {
            this.getLabData();
            if (this.preset == "company") {
                this.getAgents();
                this.getClients();
            }
        }
    }
</script>

<style lang="scss">
    .labpersonal-preloader {
        text-align: center;
    }
    .pointed {
        cursor: pointer;
    }
    .row--padding {
        margin-right: 0px;
        margin-left: 0px;
    }

    .lk-forms--loading {
        opacity: 0.6;
        cursor: progress;

        .container {
            pointer-events: none;
        }
    }

    .historyT > tbody > tr.result {
        display: table-row;
    }

    .input-group {
        width: 100%;
    }

    .result {

        &:hover {
            background-color: #f5f5f5;
        }

        & .service {
            font-weight: bold;
        }

        & .subject{
            padding-left: 20px;
        }
    }

    .results-count {
        float: right;
        padding: 0 15px 10px 15px;
        font-weight: bold;
        text-transform: uppercase;
    }
    
    .pagination--top {
        display: block;
        float: left;
    }

    .pagination li {
        cursor: pointer;
    }

    .send-pdf-block {
        margin-top: 10px;
    }

    .send-pdf-input {
        width: 250px;
    }

    .send-pdf-errors {
        margin-top: 5px;
        color: red;
        font-size: 12px;
    }

    .send-pdf-success {
        color: #00a651;
        font-weight: bold;
    }

    .mx-datepicker {
        width: 100%;
    }

    .mx-input-append {
        padding: 0;
        width: 40px;
        border: 1px solid #ccc;
        background-color: #eee;
    }

    .input-group-addon {
        border: none;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    .form-group--multiselect {

        & .v-select {
            background-color: #ffffff;
            border-radius: 4px;
        }

        & .v-select input {
            margin-top: 0;
        }

        & .v-select .dropdown-menu {
            overflow-y: auto;
        }

        & .dropdown-toggle {
            padding-top: 0;
        }

        & .dropdown-toggle:after {
            display: none;
        }

        & .v-select.unsearchable input[type=search] {
            opacity: 1;
        }

        & .no-options {
            display: none;
        }

    }

    .historyT > tbody > tr.watchCheck td .glyphicon {
        padding: 0 5px;
    }

</style>


// WEBPACK FOOTER //
// src/App.vue